<script setup></script>

<template>
  <div class="overflow-auto bg-n-surface-1 w-full">
    <router-view />
  </div>
</template>
